<script setup lang="ts">
import { ReviewSection, RenderName, RenderPhone, RenderEmail } from '@hfc/ui-core';
import { useSmallBusinessStore } from '@/application/smallBusiness/infrastructure/composition/useSmallBusinessStore';

const { smallBusinessState } = useSmallBusinessStore();

</script>
<template>
  <ReviewSection section-title="Primary Contact" :editable="false" :section-number="1">
    <template #content>
      <div class="flex w-full flex-col sm:flex-row lg:flex-row justify-between gap-4 mt-2">
        <div class="flex flex-col">
          <label class="font-medium mb-1 whitespace-nowrap text-sky-700 block">
            Name
          </label>
          <div class="flex whitespace-nowrap items-center text-xl space-x-4 lining-nums">
            <RenderName icon="user-tie" :first-name="smallBusinessState.application.company.primary_contact?.first_name" :last-name="smallBusinessState.application.company.primary_contact?.last_name" />
          </div>
        </div>
        <div class="flex flex-col">
          <label class="font-medium mb-1 whitespace-nowrap text-sky-700 block">
            Phone
          </label>
          <div class="flex items-center text-xl space-x-4 lining-nums">
            <RenderPhone :phone="smallBusinessState.application.company.primary_contact?.phone?.toString()" />
          </div>
        </div>
        <div class="flex flex-col">
          <label class="font-medium mb-1 whitespace-nowrap text-sky-700 block">
            Email Address
          </label>
          <div class="flex items-center text-xl space-x-4 lining-nums">
            <RenderEmail :email="smallBusinessState.application.company.primary_contact?.email" />
          </div>
        </div>
      </div>
    </template>
  </ReviewSection>
</template>
